import React, { useState, useEffect } from 'react';

const ScrollToTopButton = () => {
    const [isVisible, setIsVisible] = useState(false);

    // Toggle visibility when scrolling past a certain point (e.g., 300px)
    useEffect(() => {
        const toggleVisibility = () => {
            setIsVisible(window.pageYOffset > 300);
        };

        window.addEventListener('scroll', toggleVisibility);

        // Cleanup the event listener when the component unmounts
        return () => window.removeEventListener('scroll', toggleVisibility);
    }, []);

    // Smooth scroll back to the top
    const scrollToTop = () => {
        window.scrollTo({ top: 0, behavior: 'smooth' });
    };

    return (
        <>
            {isVisible && (
                <button
                    onClick={scrollToTop}
                    className=" fixed bottom-5 right-3 z-50 bg-primary text-white flex items-center justify-center w-[45px] h-[45px] rounded-[5px] border-2 border-transparent"
                >
                    {/* Using a Unicode up arrow character */}
                    <span className="text-lg">^</span>
                </button>
            )}
        </>
    );
};

export default ScrollToTopButton;
